import { Link } from '~/components/link';
import { useFolderPath } from '~/contexts';

export const ShowLocation = ({ showFolderId }: { showFolderId: number }) => {
  const path = useFolderPath(showFolderId);
  const joinedPath = path
    .slice(1)
    .map((x) => x.name)
    .join('/');

  return (
    <Link onClick={(e) => e.stopPropagation()} to={`../${showFolderId}`}>
      /{joinedPath}
    </Link>
  );
};
